import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'

import IndexCitas from "@/views/citas/Index.vue"
import CrearCita from "@/views/citas/CrearCita.vue"
import Agenda from "@/views/reservas/Agendar.vue"
import TratamientoIndex from "@/views/tratamientos/Index.vue"
import PacientesIndex from "@/views/pacientes/Index.vue"
import NuevoPaciente from "@/views/pacientes/NuevoPaciente.vue"
import VerDetalle from "@/views/pacientes/Detalle.vue"
import CotizacionesIndex from '@/views/cotizaciones/Index.vue'

import {UserAuth} from "@/models/UserAuth";
import PerfilUsuario from '@/views/usuarios/Perfil.vue'
import InicioView from '@/views/inicio/Index.vue'
import PagosIndex from '@/views/pagos/Index.vue'
import ReporteIngresos from '@/views/reportes/Ingresos.vue'
import ReporteConvenio from '@/views/reportes/PacientesPorSeguro.vue'
import ReporteTratamiento from '@/views/reportes/Tratamientos.vue'

Vue.use(VueRouter)

function can(name: string) {
    const permisos = JSON.parse(localStorage.getItem("permisosApp")!);
    return permisos.find((x:any) => x.name === name) !== undefined;
  }

const routes = [
    {
        path: '/',
        redirect: '/login' // Redirige la raíz a la página de inicio de sesión
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Login.vue'),
        //meta: { requiresAuth: false }
    },
    {

        path: '/',
        component: () => import('@/layouts/default/View.vue'),
        children: [
            {
                path: '/home',
                name: 'home',
                meta: { requiresAuth: true },
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "home" */ '@/views/AboutView.vue'),
            },
            {
                path: '/home2',
                name: 'home2',
                meta: { requiresAuth: true },
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "home" */ '@/views/home/Index.vue'),
            },
            {
                path: '/citas-medicas',
                name: 'citas-medicas',
                component: IndexCitas,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },
            {
                path: '/nueva-cita',
                name: 'nueva-cita',
                component: CrearCita,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },
            {
                path: '/agenda',
                name: 'agenda',
                component: Agenda,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },
            {
                path: '/tratamientos',
                name: 'tratamientos',
                component: TratamientoIndex,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },
            {
                path: '/pacientes',
                name: 'pacientes',
                component: PacientesIndex,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },
            {
                path: '/nuevo-paciente',
                name: 'nuevo-paciente',
                component: NuevoPaciente,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },
            {
                path: '/ver-detalle',
                name: 'ver-detalle',
                component: VerDetalle,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },
            
            {
                path: '/cotizaciones',
                name: 'cotizaciones',
                component: CotizacionesIndex,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },
            {
                path: '/perfil',
                name: 'perfil',
                component: PerfilUsuario,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },
            {
                path: '/inicio',
                name: 'inicio',
                component: InicioView,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },
            {
                path: '/pagos',
                name: 'pagos',
                component: PagosIndex,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },
            {
                path: '/reporte-ingresos',
                name: 'reporte-ingresos',
                component: ReporteIngresos,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },
            {
                path: '/reporte-tratamiento',
                name: 'reporte-tratamiento',
                component: ReporteTratamiento,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },
            {
                path: '/reporte-convenio',
                name: 'reporte-convenio',
                component: ReporteConvenio,
                meta: {requiresAuth: true},
                props: true,
                beforeEnter: (to:any, from:any, next:any) => {
                    if (can('administrador')) next()
                    else next({name: "error_permisos"})
                }
            },

],
},
   


    {
        path: '/404',
        name: 'error',
        component: () => import('../components/Error.vue'),
    },
    {
        path: '/403',
        name: 'error_permisos',
        component: () => import('../components/ErrorPermisos.vue'),
    },
    {
        path: '/',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to, from, next)  => {
    if (to.meta?.requiresAuth && !localStorage.getItem('token')) {
        console.log('sdsdsds')
        next({path: '/login'});
      } else {
        console.log('aqui')
        next();
      }
});

export default router
